export function RequiredMark() {
  return <span className="text-red-500 ml-0.5">*</span>;
}

export function FieldError({ message }: { message?: string }) {
  if (!message) return null;
  return <p className="mt-1 text-xs text-red-600 dark:text-red-400">{message}</p>;
}
